exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[role=button],[role=tab],a,button{cursor:pointer}html[dir] input,html[dir] textarea{-webkit-box-shadow:none!important;box-shadow:none!important}.hGgi6S755O5ZnX\\+DK4komA\\=\\={-ms-touch-action:none;touch-action:none}html[dir] .hGgi6S755O5ZnX\\+DK4komA\\=\\={background:rgba(0,0,0,.7)}", ""]);
// Exports
exports.locals = {
	"overlay": "hGgi6S755O5ZnX+DK4komA=="
};